import React, { useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import { StoreBadges } from './StoreBadges';
import './NewsletterSignup.scss';

const ErrorMessage = ({ submitError }) => {
  if (!submitError) return null;
  const alreadySubscribed = submitError.indexOf('already subscribed') || submitError.indexOf('too many requests');
  const message = alreadySubscribed
    ? "Looks like you're already subscribed to our mailing list."
    : 'Uh oh! Something went wrong!';
  return <span className="newsletter-signup-error">{message}</span>;
};

const SuccessMessage = ({ submitSuccess }) => {
  if (!submitSuccess) return null;
  return (
    <div className="newsletter-signup-success">
      <span>Thanks for joining our mailing list</span>
    </div>
  );
};

export const NewsletterSignup = ({ title, text }) => {
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [email, setEmail] = useState(null);

  const handleSubmit = async event => {
    event.preventDefault();
    setSubmitting(true);
    setSubmitError(false);
    setSubmitSuccess(false);
    const result = await addToMailchimp(email);
    if (result.result === 'success') {
      setSubmitting(false);
      setSubmitSuccess(true);
      setEmail(null);
    } else {
      setSubmitting(false);
      setSubmitError(result.msg);
    }
  };

  const handleChange = event => {
    setEmail(event.target.value);
  };

  return (
    <section className="newsletter-signup">
      <div className="wrapper">
        <h1 className="newsletter-signup-title">Stay tuned</h1>
        <div className="newsletter-signup-content">
          <p>Get the newest deals delivered to your inbox.</p>
        </div>
        <div className="newsletter-signup-form">
          <ErrorMessage submitError={submitError} />
          <SuccessMessage submitSuccess={submitSuccess} />
          {!submitSuccess && (
            <form className="newsletter-signup-inputs" name="subscribe" onSubmit={handleSubmit}>
              <label htmlFor="email" className={`${submitError ? 'has-error' : ''}`} aria-label="Email">
                <input
                  type="email"
                  id="email"
                  disabled={submitting}
                  name="email"
                  placeholder="Enter your email address"
                  onChange={handleChange}
                  value={email || ''}
                  required
                />
              </label>
              <button
                className={`${submitting ? 'button submitting' : 'button'}`}
                aria-label="Send"
                type="submit"
                disabled={submitting}
              >
                <span>{submitting ? 'Submitting' : 'Join'}</span>
              </button>
            </form>
          )}
          <StoreBadges />
        </div>
      </div>
    </section>
  );
};
